<template>
  <div class="col bg-light min-vh-100 home-quick-view">
    <Modal
      v-if="popupTriggers.searchesButtonTrigger"
      :TogglePopup="() => TogglePopup('searchesButtonTrigger')"
    >
      <div class="quick-search-results">
        <header class="quick-search-results-header">
          <span class="quick-search-results-eyebrow">Quick search</span>
          <h1>Search results</h1>
          <p>{{ searchUsers.length }} users · {{ searchSims.length }} SIMs</p>
        </header>

        <section class="quick-search-results-section">
          <div class="quick-search-results-heading">
            <h2>Users <span>({{ searchUsers.length }})</span></h2>
          </div>

          <div v-if="searchUsers.length === 0" class="quick-search-results-empty">
            No matching users found.
          </div>

          <div v-else class="quick-search-results-table-wrap">
          <table class="table table-hover quick-search-results-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Cellnumber</th>
            <th>Country</th>
            <th>Email</th>
            <th>Created</th>
            <th>Last Group</th>
            <th>Places</th>
            <th>Created Groups</th>
            <th>All Groups</th>
            <th>Devices</th>
            <th>App</th>
            <th>Phone</th>
            <th>Licenses</th>
            <th>Recent License</th>
            <th>Notes</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="searchUser in searchUsers" :key="searchUser.user_id || searchUser.cellnumber">
            <td>{{ searchUser.name }}</td>
            <td>{{ searchUser.cellnumber }}</td>
            <td>{{ searchUser.country }}</td>
            <td>{{ searchUser.email }}</td>
            <td>{{ searchUser.created_date }}</td>
            <td>{{ searchUser.last_joined_date }}</td>
            <td>{{ searchUser.places }}</td>
            <td>{{ searchUser.created_hunts }}</td>
            <td>{{ searchUser.all_hunts }}</td>
            <td>{{ searchUser.deviceslength }}</td>
            <td>{{ searchUser.app }}</td>
            <td>{{ searchUser.phone }}</td>
            <td>{{ searchUser.licenseslength }}</td>
            <td>{{ searchUser.last_license_date }}</td>
            <td>{{ searchUser.noteslength }}</td>
            <td>
              <button class="btn btn-sm quick-search-details-button" title="Open user details" aria-label="Open user details" @click="usersModal(searchUser)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-info-circle"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
          </div>
        </section>

        <section class="quick-search-results-section">
          <div class="quick-search-results-heading">
            <h2>SIMs <span>({{ searchSims.length }})</span></h2>
          </div>

          <div v-if="searchSims.length === 0" class="quick-search-results-empty">
            No matching SIMs found.
          </div>

          <div v-else class="quick-search-results-table-wrap">
          <table class="table table-hover quick-search-results-table">
        <thead>
          <tr>
            <th>Number</th>
            <th>Valid Until</th>
            <th>Deleted</th>
            <th>Status</th>
            <th>Operator</th>
            <th>IMEI</th>
            <th>Brand</th>
            <th>Team</th>
            <th>Notes</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="sim in searchSims" :key="sim.simId || sim.phoneNumber">
            <td>{{ sim.phoneNumber }}</td>
            <td>{{ sim.validUntil }}</td>
            <td>{{ sim.deleted }}</td>
            <td>{{ sim.status }}</td>
            <td>{{ sim.operator }}</td>
            <td>{{ sim.imei }}</td>
            <td>{{ sim.brand }}</td>
            <td>{{ getSimTeamDisplay(sim) || '-' }}</td>
            <td>{{ sim.notes }}</td>
            <td>
              <button
                class="btn btn-sm quick-search-details-button"
                title="Open SIM details"
                aria-label="Open SIM details"
                @click="showSimDetails(sim)"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16" aria-hidden="true">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
          </div>
        </section>
      </div>
    </Modal>

    <header class="home-quick-header"><h1>Quick user tools</h1></header>

    <section class="lookup-section home-quick-section">
      <div class="home-quick-section-heading"><h2>Search</h2></div>
      <div class="row g-2 align-items-end">
        <div class="col-md-6 col-lg-4">
          <label class="form-label small fw-bold" for="quick-user-search">Search</label>
          <input
            id="quick-user-search"
            v-model="searchInput"
            type="search"
            class="form-control"
            placeholder="Cellnumber, name, email"
            @keydown.enter.prevent="searchFor"
          />
        </div>
        <div class="col-auto">
          <button
            class="btn btn-outline-dark btn-rounded"
            :disabled="loadingSearch"
            @click="searchFor"
          >
            <span v-if="!loadingSearch">Search</span>
            <span v-else>Loading...</span>
          </button>
        </div>
        <div v-if="loadingSearch" class="col-auto d-flex align-items-center">
          <div class="lds-ring-sm">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>

      <div v-if="searchError" class="alert alert-danger py-2 mt-3 mb-0">
        {{ searchError }}
      </div>
    </section>

    <section class="lookup-section home-quick-section">
      <div class="home-quick-section-heading"><h2>Quick Add License</h2></div>

      <div class="row g-2 align-items-end mt-1">
        <div class="col-md-4 col-lg-3">
          <label class="form-label small fw-bold" for="quick-license-phone-number">Cellnumber</label>
          <input
            id="quick-license-phone-number"
            v-model="quickLicensePhoneNumber"
            type="search"
            class="form-control"
            placeholder="+372..."
          />
        </div>
        <div class="col-md-4 col-lg-4">
          <label class="form-label small fw-bold" for="quick-license-comment">Comment</label>
          <input
            id="quick-license-comment"
            v-model="quickLicenseComment"
            type="text"
            class="form-control"
            placeholder="Comment"
          />
        </div>
        <div class="col-md-4 col-lg-3">
          <label class="form-label small fw-bold" for="quick-license-date">Valid until</label>
          <input
            id="quick-license-date"
            v-model="quickLicenseDate"
            type="date"
            class="form-control"
          />
        </div>
        <div class="col-auto">
          <button
            class="btn btn-outline-dark btn-rounded"
            :disabled="isSubmittingLicense"
            @click="submitQuickLicense"
          >
            <span v-if="!isSubmittingLicense">Add License</span>
            <span v-else>Saving...</span>
          </button>
        </div>
      </div>

      <div v-if="quickLicenseError" class="alert alert-danger py-2 mt-3 mb-0">
        {{ quickLicenseError }}
      </div>

      <div v-if="quickLicenseSuccess" class="alert alert-success py-2 mt-3 mb-0">
        {{ quickLicenseSuccess }}
      </div>
    </section>

    <UserDetailsModal
      :visible="popupTriggers.usersButtonTrigger"
      :user="user"
      :toggle-popup="() => TogglePopup('usersButtonTrigger')"
    />

    <SimDetailsModal
      :visible="popupTriggers.simDetailsTrigger"
      :sim="selectedSim"
      :team-display="getSimTeamDisplay(selectedSim)"
      :toggle-popup="() => TogglePopup('simDetailsTrigger')"
      @open-user="openSimOwnerDetails"
      @open-team="openSimTeamDetails"
    />
  </div>
</template>

<script>
import axios from 'axios'
import * as $ from 'alga-js'
import { ref } from 'vue'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import Modal from '@/components/Modal.vue'
import UserDetailsModal from '@/components/UserDetailsModal.vue'
import SimDetailsModal from '@/components/SimDetailsModal.vue'
import { API_ENDPOINTS } from '@/config/api'
import { normalizeAdminUser, normalizeAdminUsers } from '@/utils/userUtils'
import { getSimTeamLinkDisplay } from '@/utils/simTeamLink'

let cachedSearchUsers = null
let cachedSearchUsersPromise = null
let cachedSearchSims = null
let cachedSearchSimsPromise = null
let cachedSearchTeams = null
let cachedSearchTeamsPromise = null

function createEmptyUser() {
  return {
    teamsinfo: [],
    licenses: [],
    devices: [],
    notes: []
  }
}

function formatDateInput(dateValue) {
  const date = new Date(dateValue)
  if (Number.isNaN(date.getTime())) return ''

  const year = date.getFullYear()
  const month = (`0${date.getMonth() + 1}`).slice(-2)
  const day = (`0${date.getDate()}`).slice(-2)

  return `${year}-${month}-${day}`
}

function getDefaultLicenseDate() {
  return formatDateInput(Date.now() + (365 * 24 * 60 * 60 * 1000))
}

export default {
  name: 'QuickUserLookup',
  components: {
    Modal,
    UserDetailsModal,
    SimDetailsModal
  },
  setup() {
    const popupTriggers = ref({
      searchesButtonTrigger: false,
      usersButtonTrigger: false,
      simDetailsTrigger: false
    })

    const TogglePopup = (trigger) => {
      popupTriggers.value[trigger] = !popupTriggers.value[trigger]
    }

    return {
      popupTriggers,
      TogglePopup
    }
  },
  data() {
    return {
      searchInput: '',
      loadingSearch: false,
      searchError: '',
      isSubmittingLicense: false,
      quickLicenseError: '',
      quickLicenseSuccess: '',
      quickLicensePhoneNumber: '',
      quickLicenseComment: '',
      quickLicenseDate: getDefaultLicenseDate(),
      searchUsers: [],
      searchSims: [],
      availableTeams: [],
      selectedSim: {},
      user: createEmptyUser()
    }
  },
  methods: {
    normalizeArray(value) {
      return Array.isArray(value) ? value.filter((item) => item != null) : []
    },
    normalizePhoneSearchValue(value) {
      return String(value ?? '').replace(/\s+/g, '').trim()
    },
    phoneNumbersMatch(left, right) {
      const normalizedLeft = this.normalizePhoneSearchValue(left)
      const normalizedRight = this.normalizePhoneSearchValue(right)

      if (!normalizedLeft || !normalizedRight) {
        return false
      }

      if (normalizedLeft === normalizedRight) {
        return true
      }

      if (normalizedLeft.startsWith('+') && normalizedLeft.slice(1) === normalizedRight) {
        return true
      }

      if (normalizedRight.startsWith('+') && normalizedRight.slice(1) === normalizedLeft) {
        return true
      }

      return false
    },
    looksLikePhoneNumber(value) {
      return /^\+?\d{5,}$/.test(this.normalizePhoneSearchValue(value))
    },
    getDirectLookupApiBase() {
      const configuredApiBase = String(API_ENDPOINTS.TIW_API || '').trim()

      if (typeof window !== 'undefined') {
        const hostname = String(window.location.hostname || '').toLowerCase()
        const isLocalBrowser = hostname === 'localhost' || hostname === '127.0.0.1'

        if (isLocalBrowser) {
          return 'http://localhost:3002/api'
        }
      }

      return configuredApiBase || '/api'
    },
    resetSearchResults() {
      this.searchUsers = []
      this.searchSims = []
    },
    getSimTeamDisplay(sim) {
      return getSimTeamLinkDisplay(sim?.pricingModel, this.availableTeams)
    },
    showSimDetails(sim) {
      this.selectedSim = sim || {}
      this.popupTriggers.searchesButtonTrigger = false
      this.popupTriggers.simDetailsTrigger = true
    },
    async openSimOwnerDetails(owner) {
      this.popupTriggers.simDetailsTrigger = false
      await this.usersModal(owner)
    },
    openSimTeamDetails(teamName) {
      const name = String(teamName || '').trim()
      if (!name) return
      this.popupTriggers.simDetailsTrigger = false
      this.$router.push({ name: 'Teams', query: { team: name } })
    },
    searchCollection(collection, query) {
      const items = this.normalizeArray(collection)
      return query ? $.array.search(items, query) : items
    },
    getLicenseCreator() {
      const currentUserEmail = firebase.auth()?.currentUser?.email

      if (typeof currentUserEmail !== 'string' || currentUserEmail.trim().length === 0) {
        return 'Admin'
      }

      let name = currentUserEmail.split('@')[0].split('.')[0]
      name = name.charAt(0).toUpperCase() + name.slice(1)

      return name || 'Admin'
    },
    resetQuickLicenseForm() {
      this.quickLicensePhoneNumber = ''
      this.quickLicenseComment = ''
      this.quickLicenseDate = getDefaultLicenseDate()
    },
    async submitQuickLicense() {
      const phoneNumber = String(this.quickLicensePhoneNumber || '').trim()
      const comment = String(this.quickLicenseComment || '').trim()
      const validUntilDate = String(this.quickLicenseDate || '').trim()

      if (phoneNumber.length === 0) {
        this.quickLicenseError = 'Sisesta kasutaja telefoninumber.'
        this.quickLicenseSuccess = ''
        return
      }

      if (validUntilDate.length === 0) {
        this.quickLicenseError = 'Sisesta litsentsi kuupäev.'
        this.quickLicenseSuccess = ''
        return
      }

      const validUntil = new Date(validUntilDate)

      if (Number.isNaN(validUntil.getTime())) {
        this.quickLicenseError = 'Litsentsi kuupäev ei ole korrektne.'
        this.quickLicenseSuccess = ''
        return
      }

      this.isSubmittingLicense = true
      this.quickLicenseError = ''
      this.quickLicenseSuccess = ''

      try {
        await axios.post(`${API_ENDPOINTS.TIW_API}/rest/lic`, {
          created: Date.now(),
          creator: this.getLicenseCreator(),
          comment,
          valid: true,
          validUntil: validUntil.getTime(),
          phoneNumber
        })

        this.quickLicenseSuccess = `Litsents lisatud kasutajale ${phoneNumber}.`
        this.resetQuickLicenseForm()
      } catch (error) {
        this.quickLicenseError = 'Litsentsi lisamine ebaõnnestus.'
      } finally {
        this.isSubmittingLicense = false
      }
    },
    prepareTeams(teams) {
      return this.normalizeArray(teams).map((team) => {
        const permissions = this.normalizeArray(team.permissions)
        const preparedTeam = {
          ...team,
          permissions,
          phoneNumber: '',
          ownerName: '',
          teamName: team?.name || ''
        }

        for (let index = 0; index < permissions.length; index += 1) {
          if (permissions[index].permission === 'owner' && permissions[index].user) {
            preparedTeam.phoneNumber = permissions[index].user.phoneNumber
            preparedTeam.ownerName = permissions[index].user.name
            break
          }
        }

        return preparedTeam
      })
    },
    buildTeamsInfo(cellnumber, teams) {
      const teamsinfo = []

      if (!cellnumber || !Array.isArray(teams)) {
        return teamsinfo
      }

      for (let teamIndex = 0; teamIndex < teams.length; teamIndex += 1) {
        const team = teams[teamIndex]

        if (!Array.isArray(team.permissions)) continue

        for (let permissionIndex = 0; permissionIndex < team.permissions.length; permissionIndex += 1) {
          const permission = team.permissions[permissionIndex]

          if (cellnumber === permission?.user?.phoneNumber) {
            teamsinfo.push({
              teamName: team.teamName,
              teamRole: permission.permission,
              teamOwner: team.ownerName,
              teamOwnerNumber: team.phoneNumber
            })
          }
        }
      }

      return teamsinfo
    },
    getUsersFromStore() {
      if (Array.isArray(this.$store?.state?.users) && this.$store.state.users.length > 0) {
        return this.normalizeArray(this.$store.state.users)
      }

      return []
    },
    async loadUsersForSearch() {
      const storeUsers = this.getUsersFromStore()
      if (storeUsers.length > 0) {
        return storeUsers
      }

      if (Array.isArray(cachedSearchUsers)) {
        return cachedSearchUsers
      }

      if (cachedSearchUsersPromise) {
        return cachedSearchUsersPromise
      }

      cachedSearchUsersPromise = axios
        .get(`${API_ENDPOINTS.TIW_API}/users`)
        .then((response) => {
          cachedSearchUsers = normalizeAdminUsers(this.normalizeArray(response.data))
          return cachedSearchUsers
        })
        .finally(() => {
          cachedSearchUsersPromise = null
        })

      return cachedSearchUsersPromise
    },
    async loadSimsForSearch() {
      if (Array.isArray(cachedSearchSims)) {
        return cachedSearchSims
      }

      if (cachedSearchSimsPromise) {
        return cachedSearchSimsPromise
      }

      cachedSearchSimsPromise = axios
        .get(`${API_ENDPOINTS.TIW_API}/sim/all`)
        .then((response) => {
          cachedSearchSims = this.normalizeArray(response.data)
          return cachedSearchSims
        })
        .finally(() => {
          cachedSearchSimsPromise = null
        })

      return cachedSearchSimsPromise
    },
    async loadTeams() {
      if (Array.isArray(cachedSearchTeams)) {
        return cachedSearchTeams
      }

      if (cachedSearchTeamsPromise) {
        return cachedSearchTeamsPromise
      }

      cachedSearchTeamsPromise = axios
        .get(`${API_ENDPOINTS.TIW_API}/team/list_all`)
        .then((response) => {
          cachedSearchTeams = this.prepareTeams(response.data)
          return cachedSearchTeams
        })
        .finally(() => {
          cachedSearchTeamsPromise = null
        })

      return cachedSearchTeamsPromise
    },
    async loadUserByPhoneNumber(phoneNumber) {
      try {
        const response = await axios.get(`${this.getDirectLookupApiBase()}/users/${encodeURIComponent(phoneNumber)}`)
        if (!response?.data) {
          return null
        }

        return normalizeAdminUser(response.data)
      } catch (error) {
        if (error?.response?.status === 404) {
          return null
        }

        throw error
      }
    },
    async fallbackSearchUserByPhoneNumber(phoneNumber) {
      const users = await this.loadUsersForSearch()
      const normalizedPhoneNumber = this.normalizePhoneSearchValue(phoneNumber)

      return users.find((user) => this.phoneNumbersMatch(user?.cellnumber, normalizedPhoneNumber)) || null
    },
    async searchByPhoneNumber(phoneNumber) {
      const normalizedPhoneNumber = this.normalizePhoneSearchValue(phoneNumber)
      let user = await this.loadUserByPhoneNumber(normalizedPhoneNumber)

      if (!user) {
        user = await this.fallbackSearchUserByPhoneNumber(normalizedPhoneNumber)
      }

      this.searchUsers = user ? [user] : []
      this.searchSims = []
    },
    async searchFor() {
      const query = String(this.searchInput || '').trim()

      if (query.length === 0) {
        this.searchError = 'Sisesta otsing.'
        return
      }

      this.loadingSearch = true
      this.searchError = ''
      this.resetSearchResults()

      try {
        if (this.looksLikePhoneNumber(query)) {
          await this.searchByPhoneNumber(query)

          if (this.searchUsers.length === 0) {
            this.searchError = 'No matches found.'
            return
          }

          if (!this.popupTriggers.searchesButtonTrigger) {
            this.TogglePopup('searchesButtonTrigger')
          }

          return
        }

        const [users, sims, teams] = await Promise.all([
          this.loadUsersForSearch(),
          this.loadSimsForSearch(),
          this.loadTeams()
        ])

        this.searchUsers = this.searchCollection(users, query)
        this.searchSims = this.searchCollection(sims, query)
        this.availableTeams = teams

        if (this.searchUsers.length === 0 && this.searchSims.length === 0) {
          if (this.popupTriggers.searchesButtonTrigger) {
            this.TogglePopup('searchesButtonTrigger')
          }
          this.searchError = 'No matches found.'
          return
        }

        if (!this.popupTriggers.searchesButtonTrigger) {
          this.TogglePopup('searchesButtonTrigger')
        }
      } catch (error) {
        this.searchError = 'Otsingu andmete laadimine ebaõnnestus.'
      } finally {
        this.loadingSearch = false
      }
    },
    async usersModal(searchUser) {
      try {
        const normalizedUser = normalizeAdminUser(searchUser)
        const [activityResponse, teams] = await Promise.all([
          axios.get(`${API_ENDPOINTS.TIW_API}/activity/${encodeURIComponent(normalizedUser.cellnumber)}`),
          this.loadTeams()
        ])

        normalizedUser.notes = this.normalizeArray(activityResponse.data)
        normalizedUser.teamsinfo = this.buildTeamsInfo(normalizedUser.cellnumber, teams)
        this.user = normalizedUser

        if (this.popupTriggers.searchesButtonTrigger) {
          this.TogglePopup('searchesButtonTrigger')
        }

        if (!this.popupTriggers.usersButtonTrigger) {
          this.TogglePopup('usersButtonTrigger')
        }
      } catch (error) {
        this.searchError = 'Kasutaja detailide laadimine ebaõnnestus.'
      }
    }
  }
}
</script>

<style scoped>
.home-quick-view { padding: 4px 18px 18px; color: #202629; }
.home-quick-header { margin: 0 -18px 18px; padding: 20px 22px; border-left: 4px solid #f56600; border-radius: 0 0 9px 9px; background: #202629; color: #fff; }
.home-quick-header h1 { margin: 0; font-size: 22px; font-weight: 700; }
.lookup-section { max-width: 960px; }
.home-quick-section { margin-top: 18px; padding: 14px; border: 1px solid #e1e5e6; border-radius: 9px; background: #fbfcfc; }
.home-quick-section-heading { margin-bottom: 12px; }
.home-quick-section-heading h2 { margin: 0; color: #202629; font-size: 14px; font-weight: 700; }
.home-quick-section .form-label { margin-bottom: 5px; color: #40545e; font-size: 10px; font-weight: 700; text-transform: uppercase; }
.home-quick-section .form-control:focus { border-color: #f56600; box-shadow: 0 0 0 .15rem rgba(245, 102, 0, .16); }
.home-quick-section .btn { border-color: #d7dfe2; background: #fff; color: #202629; font-size: 10px; }
.home-quick-section .btn:hover { border-color: #f56600; color: #f56600; }
.home-quick-section .row > .col-auto:last-child .btn { border-color: #f56600; background: #f56600; color: #fff; }
.home-quick-section .row > .col-auto:last-child .btn:hover { border-color: #d95700; background: #d95700; color: #fff; }
.quick-search-results { width: min(1460px, calc(100vw - 64px)); color: #202629; }
.quick-search-results-header { margin: -32px -32px 20px; padding: 22px 70px 22px 28px; border-left: 5px solid #f56600; border-radius: 0 0 9px 9px; background: #202629; color: #fff; }
.quick-search-results-eyebrow { display: block; margin-bottom: 5px; color: #f56600; font-size: 10px; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; }
.quick-search-results-header h1 { margin: 0; font-size: 23px; font-weight: 700; }
.quick-search-results-header p { margin: 5px 0 0; color: #b9c3c8; font-size: 11px; }
.quick-search-results-section { margin-top: 18px; padding: 14px; border: 1px solid #dce3e6; border-radius: 9px; background: #fbfcfc; }
.quick-search-results-heading { margin-bottom: 10px; }
.quick-search-results-heading h2 { margin: 0; color: #202629; font-size: 14px; font-weight: 700; }
.quick-search-results-heading h2 span { color: #65737b; font-weight: 500; }
.quick-search-results-empty { padding: 12px; border-radius: 7px; background: #fff; color: #68757c; font-size: 12px; }
.quick-search-results-table-wrap { overflow-x: auto; border: 1px solid #dce3e6; border-radius: 7px; background: #fff; }
.quick-search-results-table { min-width: 1080px; margin: 0; border-collapse: collapse; font-size: 10px; }
.quick-search-results-table > :not(caption) > * > * { border-right: 0; border-left: 0; box-shadow: none; }
.quick-search-results-table thead th { padding: 10px 9px; border-top: 0; border-bottom: 1px solid #aebbc1; background: #fff; color: #4d606a; font-size: 9px; font-weight: 800; letter-spacing: .025em; text-transform: uppercase; white-space: nowrap; }
.quick-search-results-table tbody td { padding: 10px 9px; border-top: 0; border-bottom: 1px solid #e0e6e8; background: #fff; vertical-align: middle; white-space: nowrap; }
.quick-search-results-table tbody tr:last-child td { border-bottom: 0; }
.quick-search-results-table tbody tr:hover td { background: #f6f8f9; }
.quick-search-details-button { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; padding: 0; border: 1px solid #7b8b93; border-radius: 6px; background: #fff; color: #202629; }
.quick-search-details-button:hover { border-color: #f56600; background: #f56600; color: #fff; }
@media (max-width: 700px) { .home-quick-view { padding: 4px 10px 12px; } .home-quick-header { margin: 0 -10px 14px; padding: 16px; } }
@media (max-width: 700px) { .quick-search-results { width: calc(100vw - 32px); } .quick-search-results-header { margin: -32px -32px 16px; padding: 18px 58px 18px 20px; } .quick-search-results-section { padding: 10px; } }

th,
td,
tr,
input,
button {
  font-size: 10px;
}

.lds-ring-sm {
  display: inline-block;
  position: relative;
  width: 32px;
  height: 32px;
}

.lds-ring-sm div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 24px;
  height: 24px;
  margin: 4px;
  border: 4px solid #000;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}

.lds-ring-sm div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring-sm div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring-sm div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
